module.exports = __webpack_public_path__ + "img/i-vacation.378afb6f.png";